export default __webpack_public_path__ + "static/media/about_us_bill.7b8922ca.png";